import {
  findDepartementFieldRaw,
  formatDepartmentDisplay,
  getDeptDisplayLabel,
  parseDepartmentCodes,
} from "@/lib/departementDisplay";

function normalizeSearchText(s) {
  return String(s ?? "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

/**
 * Recherche texte marketplace : titre, description, secteur, localisation,
 * département (champ ou location), champs qualification publics.
 */
export function dossierMatchesMarketplaceSearch(dossier, query) {
  const q = normalizeSearchText(query);
  if (!q) return true;

  const parts = [];
  const add = (v) => {
    if (v == null) return;
    const s = normalizeSearchText(v);
    if (s) parts.push(s);
  };

  add(dossier.title);
  add(dossier.titre);
  add(dossier.description);
  add(dossier.secteur);
  add(dossier.location);
  add(dossier.seller_name);
  add(dossier.type === "recherche" ? "recherche" : dossier.type === "vente" ? "vente offre" : dossier.type);

  const deptLabel = getDeptDisplayLabel(dossier);
  add(deptLabel);
  add(formatDepartmentDisplay(findDepartementFieldRaw(dossier).raw));

  const cf =
    dossier?.custom_fields && typeof dossier.custom_fields === "object" && !Array.isArray(dossier.custom_fields)
      ? dossier.custom_fields
      : {};
  for (const [key, val] of Object.entries(cf)) {
    add(key);
    if (val != null && typeof val !== "object") add(val);
  }

  const haystack = parts.join(" ");
  if (haystack.includes(q)) return true;

  const qCodes = parseDepartmentCodes(String(query ?? "").trim());
  if (qCodes.length > 0) {
    const offerCodes = [
      ...parseDepartmentCodes(deptLabel),
      ...parseDepartmentCodes(dossier.location),
      ...parseDepartmentCodes(findDepartementFieldRaw(dossier).raw),
    ];
    const unique = [...new Set(offerCodes)];
    if (qCodes.some((c) => unique.includes(c))) return true;
  }

  const tokens = q.split(/\s+/).filter((t) => t.length >= 2);
  if (tokens.length > 1) {
    return tokens.every((t) => haystack.includes(t));
  }

  return false;
}
